import React from 'react';
import { Modal, ModalFooter } from 'react-bootstrap';
import { Form } from '../../../../../components/form/Form';
import * as yup from 'yup';
import { Input } from '../../../../../components/form/Input';
import Button from '../../../../../components/button';
import { useTranslation } from 'react-i18next';
import './ExpenseGroupActions.css';

const MAX_REASON_LENGTH = 254;

type Props = {
  expenseGroupId: string | null;
  inProgress?: boolean;
  onClose: () => void;
  onDeclined: (expenseGroupId: string, reason: string | null) => void;
};

type FormData = {
  reason?: string;
};

const validationSchema = yup.object().shape<FormData>({
  reason: yup.string().notRequired(),
});

export const ExpenseGroupDeclineModal: React.FC<
  React.PropsWithChildren<Props>
> = ({ expenseGroupId, inProgress = false, onClose, onDeclined }) => {
  const { t } = useTranslation();

  const handleSubmit = (form: FormData) => {
    if (expenseGroupId) {
      onDeclined(expenseGroupId, form.reason ?? null);
    }
  };

  return (
    <Modal
      show={expenseGroupId !== null}
      onHide={onClose}
      centered
      contentClassName="border">
      <Form onSubmit={handleSubmit} validationSchema={validationSchema}>
        <Modal.Header
          closeButton
          className="card-header mt-2 pb-6 d-flex flex-column align-items-start expense-group-decline-modal-header">
          <h4 className="card-header-title expense-group-decline-modal-title mb-2">
            {t('expenses.declineModal.title')}
          </h4>
          <h4 className="card-header-title text-danger font-weight-bold small">
            {t('expenses.declineModal.subtitle')}
          </h4>
        </Modal.Header>
        <Modal.Body className="py-0">
          <Input
            type="textarea"
            name="reason"
            minRows={4}
            maxLength={MAX_REASON_LENGTH}
            placeholder={t('expenses.declineModal.placeholder')}
          />
        </Modal.Body>
        <ModalFooter className="border-top-0">
          <Button
            type="submit"
            label={t('expenses.declineModal.confirm')}
            disabled={inProgress}
            isProcessing={inProgress}
            className="py-3 px-5"
            variant="primary"
            size="lg"
          />
        </ModalFooter>
      </Form>
    </Modal>
  );
};
